export default __webpack_public_path__ + "media/images/theme/m_logo_dark-feda37e8b9c04e8d67f90958810f30f9.png";